export default {
    computed: {
        projectType() {
            return this.$store.getters.projectTypeById(this.projectTypeId)
        },
    },
}
